// Login
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_GET_ROLES = 'USER_GET_ROLES';
export const USER_ROLES_SET_STATE = 'USER_SET_ROL_STATE';
export const USER_REDIRECT = 'USER_REDIRECT';
export const USER_REGISTER = 'USER_REGISTER';
export const USER_SET_STATE = 'USER_SET_STATE';
export const USER_CHECK_LOGIN = 'USER_CHECK_LOGIN';
export const USER_SET_STORAGE = 'USER_SET_STORAGE';
export const USER_CONTRASENA_CAMBIADA = 'USER_CONTRASENA_CAMBIADA';
export const USER_RECUPERAR_CONTRASENA = 'USER_RECUPERAR_CONTRASENA';
export const USER_VERIFYEMAIL = 'USER_VERIFYEMAIL';
export const USER_GET_DATA = 'USER_GET_DATA';
export const USER_FIND = 'USER_FIND';

// General
export const CONTRASENA_CAMBIADA = 'CONTRASENA_CAMBIADA';

// Asignacion
export const ASIGNACION_ASIGNAR = 'ASIGNACION_ASIGNAR';
export const ASIGNACION_CLEAR = 'ASIGNACION_CLEAR';
export const ASIGNACION_SET_STATE = 'ASIGNACION_SET_STATE';
export const ASIGNACION_SELECCIONAR_VEHICULO = 'ASIGNACION_SELECCIONAR_VEHICULO';

// Seleccionador
export const SELECCIONADOR_SET_LISTA = 'SELECCIONADOR_SET_LISTA';
export const SELECCIONADOR_CLEAR_LISTA = 'USUARIOS_LISTA_SET';
export const SELECCIONADOR_CLOSE = 'SELECCIONADOR_CLOSE';
export const SELECCIONADOR_OPEN = 'SELECCIONADOR_OPEN';

// Dashboard
export const DASHBOARD_CHANGE_TITLE = 'DASHBOARD_CHANGE_TITLE';

// Snackbar
export const SNACKBAR_SHOW = 'SNACKBAR_SHOW';
export const SNACKBAR_HIDE = 'SNACKBAR_HIDE';

// Loadingbar
export const LOADINGBAR_SHOW = 'LOADINGBAR_SHOW';
export const LOADINGBAR_HIDE = 'LOADINGBAR_HIDE';

// Sockets
export const SOCKET_JOIN = 'SOCKET_JOIN';
export const SOCKET_LEAVE = 'SOCKET_LEAVE';
export const SOCKETS_GENERAL_START = 'SOCKETS_GENERAL_START';

// Maps api
export const REVERSE_GEOCODING = 'REVERSE_GEOCODING';

// Paradas
export const PARADAS_GET = 'PARADAS_GET';
export const PARADAS_SET = 'PARADAS_SET';
export const PARADAS_CLEAR = 'PARADAS_CLEAR';
export const PARADAS_DELETE = 'PARADAS_DELETE';
export const PARADAS_SUGERIDAS_SET = 'PARADAS_SUGERIDAS_SET';
export const PARADAS_SUGERIDAS_GET = 'PARADAS_SUGERIDA_GET';
export const PARADAS_SET_STATE = 'PARADAS_SET_STATE';
export const PARADAS_GET_BY_ID = 'PARADAS_GET_BY_ID';
export const PARADAS_VIAJES_GET = 'PARADAS_VIAJES_GET';
export const PARADAS_ADD_MARKER = 'PARADAS_ADD_MARKER';
export const PARADAS_RUTINAS_GET = 'PARADAS_RUTINAS_GET';
export const PARADAS_BORRAR_RESTR = 'PARADAS_BORRAR_RESTR';
export const PARADAS_AGREGAR_RESTR = 'PARADAS_AGREGAR_RESTR';
export const PARADAS_ACTUALIZAR_STATE = 'PARADAS_ACTUALIZAR_STATE';

// Abonados
export const ABONADOS_GET = 'ABONADOS_GET';
export const ABONADOS_SET = 'ABONADOS_SET';
export const ABONADOS_CLEAR = 'ABONADOS_CLEAR';
export const ABONADOS_GET_BY_ID = 'ABONADOS_GET_BY_ID';
export const ABONADOS_SET_STATE = 'ABONADOS_SET_STATE';
export const ABONADOS_SET_ABONO = 'ABONADOS_SET_ABONO';
export const ABONADOS_FIND_BYID = 'ABONADOS_FIND_BYID';
export const ABONADOS_GET_ACTIVOS = 'ABONADOS_GET_ACTIVOS';
export const ABONADOS_SET_IN_STATE = 'ABONADOS_SET_IN_STATE';
export const ABONADOS_SET_LISTA = 'ABONADOS_SET_LISTA';
export const ABONADOS_DELETE_STATE = 'ABONADOS_DELETE_STATE';
export const ABONADOS_DELETE_ABONO = 'ABONADOS_DELETE_ABONO';
export const ABONADOS_SET_EXTENSION = 'ABONADOS_SET_EXTENSION';
export const ABONADOS_GET_LAST_ABONO = 'ABONADOS_GET_LAST_ABONO';
export const ABONADOS_GET_TRAYECTOS_PARADAS = 'ABONADOS_GET_TRAYECTOS_PARADAS';
export const ABONADOS_GET_RESERVAS_AUTOMATICAS = 'ABONADOS_GET_RESERVAS_AUTOMATICAS';
export const ABONADOS_SET_RESERVAS_AUTOMATICAS = 'ABONADOS_SET_RESERVAS_AUTOMATICAS';
export const ABONADOS_RESERVAS_AUTOMATICAS_GET = 'ABONADOS_RESERVAS_AUTOMATICAS_GET';
export const ABONADOS_RESERVAS_AUTOMATICAS_SET = 'ABONADOS_RESERVAS_AUTOMATICAS_SET';
export const ABONADOS_RESERVAS_AUTOMATICAS_SET_STATE = 'ABONADOS_RESERVAS_AUTOMATICAS_SET_STATE';
export const ABONADOS_GET_RESERVAS = 'ABONADOS_GET_RESERVAS';
export const ABONADOS_DELETE = 'ABONADOS_DELETE';

export const ABONADOS_DELETE_RA = 'ABONADOS_DELETE_RA';
export const ABONADOS_DELETESTATE_RA = 'ABONADOS_DELETESTATE_RA';
export const ABONADOS_ADDOREDIT_RA = 'ABONADOS_ADDOREDIT_RA';

// Feriados
export const FERIADOS_GET = 'FERIADOS_GET';
export const FERIADOS_SET = 'FERIADOS_SET';
export const FERIADOS_SET_STATE = 'FERIADOS_SET_STATE';
export const FERIADOS_DELETE = 'FERIADOS_DELETE';
export const FERIADOS_SET_STATE_BY_ID = 'FERIADOS_SET_STATE_BY_ID';

// Viajes
export const VIAJES_SET = 'VIAJES_SET';
export const VIAJES_GET = 'VIAJES_GET';
export const VIAJES_CLEAR = 'VIAJES_CLEAR';
export const VIAJES_DELETE = 'VIAJES_DELETE';
export const VIAJES_BUSCAR = 'VIAJES_BUSCAR';
export const VIAJES_SET_STATE = 'VIAJES_SET_STATE';
export const VIAJES_GET_BY_ID = 'VIAJES_GET_BY_ID';
export const VIAJES_PARADAS_GET = 'VIAJES_PARADAS_GET';
export const VIAJES_SOCKET_DATA = 'VIAJES_SOCKET_DATA';
export const VIAJES_CONCAT_STATE = 'VIAJES_CONCAT_STATE';
export const VIAJES_SET_TRAYECTO = 'VIAJES_SET_TRAYECTO';
export const VIAJES_GET_TRAYECTO = 'VIAJES_GET_TRAYECTO';
export const VIAJES_PASAJEROS_GET = 'VIAJES_PASAJEROS_GET';
export const VIAJES_FINDUPD_STATE = 'VIAJES_FINDUPD_STATE';
export const VIAJES_STREAM_TO_STATE = 'VIAJES_STREAM_STATE';
export const VIAJES_PASAJEROS_ORDER = 'VIAJES_PASAJEROS_ORDER';
export const VIAJESLOC_SOCKET_DATA = 'VIAJESLOC_SOCKET_DATA';
export const VIAJES_GET_TRAYECTOPOINTS = 'VIAJES_GET_TRAYECTOPOINTS';

// Vehiculos
export const VEHICULOS_SET = 'VEHICULOS_SET';
export const VEHICULOS_GET = 'VEHICULOS_GET';
export const VEHICULOS_CLEAR = 'VEHICULOS_CLEAR';
export const VEHICULOS_DELETE = 'VEHICULOS_DELETE';
export const VEHICULOS_GET_BY_ID = 'VEHICULOS_GET_BY_ID';
export const VEHICULOS_SET_STATE = 'VEHICULOS_SET_STATE';
export const VEHICULOS_LISTA_SET = 'VEHICULOS_LISTA_SET';
export const VEHICULOS_SET_CHOFER = 'VEHICULOS_SET_CHOFER';
export const VIAJES_SET_GRUPOS = 'VIAJES_SET_GRUPOS';
export const VEHICULOS_SELECCIONAR_CHOFER = 'VEHICULOS_SELECCIONAR_CHOFER';
export const VEHICULOS_SET_DISPOSITIVO = 'VEHICULOS_SET_DISPOSITIVO';
export const VEHICULOS_SELECCIONAR_DISPOSITIVO = 'VEHICULOS_SELECCIONAR_DISPOSITIVO';

// Rutinas
export const RUTINAS_GET = 'RUTINAS_GET';
export const RUTINAS_SET = 'RUTINAS_SET';
export const RUTINAS_CLEAR = 'RUTINAS_CLEAR';
export const RUTINAS_DELETE = 'RUTINAS_DELETE';
export const RUTINAS_LISTA_SET = 'RUTINAS_LISTA_SET';
export const RUTINAS_SET_STATE = 'RUTINAS_SET_STATE';
export const RUTINAS_PARADAS_GET = 'RUTINAS_PARADAS_GET';
export const RUTINAS_GET_BY_ID = 'RUTINAS_GET_BY_ID';
export const RUTINAS_SET_GRUPOS = 'RUTINAS_SET_GRUPOS';
export const RUTINAS_SET_GRUPOS_A_VIAJES = 'RUTINAS_SET_GRUPOS_A_VIAJES';
export const RUTINAS_SET_CAMBIOS_A_VIAJES = 'RUTINAS_SET_CAMBIOS_A_VIAJES';

// Usuarios casuales
export const USUARIOS_CASUALES_GET_BY_DOCUMENTO = 'USUARIOS_CASUALES_GET_BY_DOCUMENTO';
export const USUARIOS_CASUALES_ADD_STATE = 'USUARIOS_CASUALES_ADD_STATE';
export const USUARIOS_CASUALES_SET_STATE_BY_DOCUMENTO = 'USUARIOS_CASUALES_SET_STATE_BY_DOCUMENTO';
export const USUARIOS_CASUALES_REMOVE_STATE = 'USUARIOS_CASUALES_REMOVE_STATE';
export const USUARIOS_CASUALES_RESET_STATE = 'USUARIOS_CASUALES_RESET_STATE';

// Reservas
export const RESERVAS_SET = 'RESERVAS_SET';
export const RESERVAS_CLEAR = 'RESERVAS_CLEAR';
export const RESERVAS_CANCELAR = 'RESERVAS_CANCELAR';
export const RESERVAS_CONCRETAR = 'RESERVAS_CONCRETAR';
export const RESERVAS_ABONAR = 'RESERVAS_ABONAR';
export const RESERVAS_GET_BY_ID = 'RESERVAS_GET_BY_ID';
export const RESERVAS_SET_STATE = 'RESERVAS_SET_STATE';
export const RESERVAS_DEL_PREVIA = 'RESERVAS_DEL_PREVIA';
export const RESERVAS_SOCKET_DATA = 'RESERVAS_SOCKET_DATA';
export const RESERVAS_TEMPORAL_SET = 'RESERVAS_TEMPORAL_SET';
export const RESERVAS_VIAJES_BUSCAR = 'RESERVAS_VIAJES_BUSCAR';
export const RESERVAS_GET_PROBABLES = 'RESERVAS_GET_PROBABLES';
export const RESERVAS_SET_PROBABLES = 'RESERVAS_SET_PROBABLES';
export const RESERVAS_GET_PENDIENTES = 'RESERVAS_GET_PENDIENTES';
export const RESERVAS_TEMPORAL_DELETE = 'RESERVAS_TEMPORAL_DELETE';
export const RESERVAS_SET_STATE_BY_ID = 'RESERVAS_SET_STATE_BY_ID';
export const RESERVAS_VIAJES_GET_BY_ID = 'RESERVAS_VIAJES_GET_BY_ID';
export const RESERVAS_GET_CANTIDAD_PROBABLES = 'RESERVAS_GET_CANTIDAD_PROBABLES';
export const RESERVAS_PASAJEROS_GET_BY_DOCUMENTO = 'RESERVAS_PASAJEROS_GET_BY_DOCUMENTO';

export const REGISTROS_GET = 'REGISTROS_GET';
export const REGISTROS_CLEAR = 'REGISTROS_CLEAR';
export const REGISTROS_GET_LOGS = 'REGISTROS_GET_LOGS';
export const REGISTROS_SET_STATE = 'REGISTROS_SET_STATE';
export const REGISTROS_START_CRON = 'REGISTROS_START_CRON';
export const REGISTROS_USER_BY_ID = 'REGISTROS_USER_BY_ID';
export const REGISTROS_SOCKET_DATA = 'REGISTROS_SOCKET_DATA';
export const REGISTROS_USER_SET_STATE = 'REGISTROS_USER_SET_STATE';
export const REGISTROS_FILTER_BYACTION = 'REGISTROS_FILTER_BYACTION';
export const REGISTROS_LOGS_CONCAT_STATE = 'REGISTROS_LOGS_CONCAT_STATE';

//Roles
export const ROLES_CLEAR = 'ROLES_CLEAR';
export const ROLES_SET_STATE = 'ROLES_SET_STATE';
export const ROLES_GET_ALL = 'ROLES_GET_ALL';
export const ROLES_SET = 'ROLES_SET';
export const ROLES_GET_USER = 'ROLES_GET_USER';

//Mapa General
export const MAPAGEN_CLEAR = 'MAPAGEN_CLEAR';
export const MAPAGEN_SET_STATE = 'MAPAGEN_SET_STATE';

//Mensajes
export const MENSAJES_GET = 'MAPAGEN_GET';
export const MENSAJES_SET = 'MENSAJES_SET';
export const MENSAJES_CLEAR = 'MENSAJES_CLEAR';
export const MENSAJES_DELETE = 'MENSAJES_DELETE';
export const MENSAJES_SET_STATE = 'MENSAJES_SET_STATE';
export const MENSAJES_USUARIO_SET = 'MENSAJES_USUARIO_SET';
export const MENSAJES_USUARIO_GET = 'MENSAJES_USUARIO_GET';

//trayectos
export const TRAYECTOS_GET = 'TRAYECTOS_GET';
export const TRAYECTOS_SET = 'TRAYECTOS_SET';
export const TRAYECTOS_CLEAR = 'TRAYECTOS_CLEAR';
export const TRAYECTOS_DELETE = 'TRAYECTOS_DELETE';
export const TRAYECTOS_GETFULL = 'TRAYECTOS_GETFULL';
export const TRAYECTOS_PREVIEW = 'TRAYECTOS_PREVIEW';
export const TRAYECTOS_SET_STATE = 'TRAYECTOS_SET_STATE';
export const TRAYECTOS_DELETE_STATE = 'TRAYECTOS_DELETE_STATE';
export const TRAYECTOS_FIND_PARADA = 'TRAYECTOS_FIND_PARADA';
export const TRAYECTOS_GET_PARADAS = 'TRAYECTOS_GET_PARADAS';
export const TRAYECTOS_GET_PARADAS_USER = 'TRAYECTOS_GET_PARADAS_USER';
export const TRAYECTOS_PHOTOS_TASK = 'TRAYECTOS_PHOTOS_TASK';
export const TRAYECTOS_GET_TASKS = 'TRAYECTOS_GET_TASKS';

// reportes
export const REPORTES_GET = 'REPORTES_GET';
export const REPORTES_CLEAR = 'REPORTES_CLEAR';
export const REPORTES_SET_STATE = 'REPORTES_SET_STATE';
export const REPORTES_CUANTOS_HAY = 'REPORTES_CUANTOS_HAY';
export const REPORTES_SOLUCIONADO = 'REPORTES_SOLUCIONADO';
export const REPORTES_SOLUCIONAR_MULTIPLE = 'REPORTES_SOLUCIONAR_MULTIPLE';

//Grupos
export const GRUPOS_MODIFICAR_USUARIOS = 'GRUPOS_MODIFICAR_USUARIOS';
export const GRUPOS_MODIFICAR_USUARIOS_STATE = 'GRUPOS_MODIFICAR_USUARIOS_STATE';
export const GRUPOS_DELETE = 'GRUPOS_DELETE';
export const GRUPOS_SET = 'GRUPOS_SET';
export const GRUPOS_GET_BY_ID = 'GRUPOS_GET_BY_ID';
export const GRUPOS_GET = 'GRUPOS_GET';
export const GRUPOS_SET_STATE = 'GRUPOS_SET_STATE';
export const GRUPOS_CLEAR = 'GRUPOS_CLEAR';
export const GRUPOS_DELETE_USUARIO = 'GRUPOS_DELETE_USUARIO';

// Grupos Solicitudes
export const GRUPOS_SOLICITUDES_ACEPTAR_SELECCIONADAS = 'GRUPOS_SOLICITUDES_ACEPTAR_SELECCIONADAS';
export const GRUPOS_SOLICITUDES_SELECCIONAR = 'GRUPOS_SOLICITUDES_SELECCIONAR';
export const GRUPOS_SOLICITUDES_CUANTOS_HAY = 'GRUPOS_SOLICITUDES_CUANTOS_HAY';
export const GRUPOS_SOLICITUDES_GET = 'GRUPOS_SOLICITUDES_GET';
export const GRUPOS_SOLICITUDES_SET_STATE = 'GRUPOS_SOLICITUDES_SET_STATE';
export const GRUPOS_SOLICITUDES_CLEAR = 'GRUPOS_SOLICITUDES_CLEAR';
export const GRUPOS_SOLICITUDES_SELECCIONAR_TODAS = 'GRUPOS_SOLICITUDES_SELECCIONAR_TODAS';

// Dispositivos
export const DISPOSITIVO_GET = 'DISPOSITIVO_GET';
export const DISPOSITIVO_GET_FULL = 'DISPOSITIVO_GET_FULL';
export const DISPOSITIVO_GET_MORE_TASKS = 'DISPOSITIVO_GET_MORE_TASKS';
export const DISPOSITIVO_DELETE = 'DISPOSITIVO_DELETE';
export const DISPOSITIVO_SET_STATE = 'DISPOSITIVO_SET_STATE';
export const DISPOSITIVO_CLEAR = 'DISPOSITIVO_CLEAR';
export const DISPOSITIVO_ACCEPT = 'DISPOSITIVO_ACCEPT';
export const DISPOSITIVO_GET_CODIGO = 'DISPOSITIVO_GET_CODIGO';
export const DISPOSITIVO_REQUEST_ACTION = 'DISPOSITIVO_REQUEST_ACTION';
export const DISPOSITIVO_GET_PHOTO_URL = 'DISPOSITIVO_GET_PHOTO_URL';

// Precios
export const PRECIO_CLEAR = 'PRECIO_CLEAR';
export const PRECIO_SET_STATE = 'PRECIO_SET_STATE';
export const PRECIO_GET = 'PRECIO_GET';
export const PRECIO_SET = 'PRECIO_SET';
export const PRECIO_UPDATE_VIAJES = 'PRECIO_UPDATE_VIAJES';
export const PRECIO_GET_ACTIVOS = 'PRECIO_GET_ACTIVOS';
export const PRECIO_DELETE = 'PRECIO_DELETE';
//Penalizaciones
export const PENALIZACIONES_CLEAR = 'PENALIZACIONES_CLEAR';
export const PENALIZACIONES_SOLUCIONAR_TODAS = 'PENALIZACIONES_SOLUCIONAR_TODAS';
export const PENALIZACIONES_SOLUCIONAR = 'PENALIZACIONES_SOLUCIONAR';
export const PENALIZACIONES_SET_STATE = 'PENALIZACIONES_SET_STATE';
export const PENALIZACIONES_GET = 'PENALIZACIONES_GET';



// WEBPACK FOOTER //
// src/actionConstants.js